<template>
    <div class="shop-container apply" >
        <div class="shop-wrap">
        <!-- 线下箭馆申请 -->
        <h1>{{$t('arrowApply')}}</h1>
        
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">

                <!-- 审核中 -->
            <el-alert v-if="clubInfo.status == 1" :title="$t('underReview')" type="warning"  show-icon></el-alert>
            <el-alert v-if="clubInfo.status == 3" :title="errTitle" type="error"  show-icon></el-alert>



            <el-form-item :label="$t('type')" prop="type_id">
                <el-select v-model="form.type_id" :placeholder="$t('pleaseEnter.type')" :disabled="disable">
                <el-option :label="item.name" :value="item.id" v-for="item in arrTypeList" :key="item.id"></el-option>
                </el-select>
            </el-form-item>


            <el-form-item :label="$t('arrowName')"  prop="title">
                <el-input v-model="form.title" :placeholder="$t('pleaseEnter.arrowName')" :disabled="disable"></el-input>
            </el-form-item>

            <el-form-item :label="$t('mobile')" prop="phone">
                <el-input v-model="form.phone" type="number" :disabled="disable" :placeholder="$t('pleaseEnter.phoneNumber')"></el-input>
            </el-form-item>

            <el-form-item :label="$t('openingHours')" required>
                <el-col :span="11">
                    <el-form-item style="padding-bottom: 0" prop="value1">
                        <el-time-picker
                        :disabled="disable"
                        value-format="HH:MM:SS"
                            v-model="value1"
                            :placeholder="$t('anyPointInTime')">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-form-item style="padding-bottom: 0" prop="value2">
                        <el-time-picker
                            :disabled="disable"
                            v-model="value2"
                            value-format="HH:MM:SS"
                            :placeholder="$t('anyPointInTime')">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item :label="$t('area')"  prop="selectedOptions">
                <el-cascader :disabled="disable" size="medium" :options="options" separator=" " :placeholder="$t('pleaseSelect')" v-model="selectedOptions"></el-cascader>
            </el-form-item>

            <!-- <el-form-item :label="$t('area')"  prop="selectedOptions">
                <el-cascader size="medium" :options="options" separator=" " v-model="selectedOptions"></el-cascader>
            </el-form-item> -->
            
            <!-- 详细地址 -->
            <el-form-item :label="$t('detailedAddress')" prop="address">
                <el-input :disabled="disable" v-model="form.address" :placeholder="$t('pleaseEnter.detailedAddress')"></el-input>
            </el-form-item>
<!-- 经纬度 -->
            <el-form-item :label="$t('longitude')">
                <div @click="mapClick">
                    <el-input v-model="form.coordinate" disabled></el-input>
                </div>
            </el-form-item>

            <el-form-item :label="$t('arrowbrief')" prop="desc">
                <el-input :disabled="disable" type="textarea" v-model="form.desc" :placeholder="$t('arrowbrief')"></el-input>
            </el-form-item>

            <el-form-item :label="$t('sign')" required>
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text"> 
                          <input
                            type="file"
                            class="input-file"
                            name="avatar"
                            ref="avatarInput"
                            :disabled="disable"
                            @change="changeImage($event, 'sign')"
                            accept="image/gif, image/jpeg, image/jpg, image/png"
                        >
                        <i  v-if="sign.length > 0 && sign[0].url" class="el-icon-delete del" @click.stop="delPic('sign')"></i>
                        <img v-if="sign.length > 0 && sign[0].url" :src="sign[0].url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                </div>
            </el-form-item>

            <el-form-item :label="$t('cover')" required>
                <div class="avatar-uploader">
                     <div class="el-upload el-upload--text"> 
                          <input
                            type="file"
                            class="input-file"
                            name="avatar"
                            ref="avatarInput"
                            :disabled="disable"
                            @change="changeImage($event, 'cover')"
                            accept="image/gif, image/jpeg, image/jpg, image/png"
                        >
                        <i v-if="cover.length > 0 && cover[0].url" class="el-icon-delete del" @click.stop="delPic('cover')"></i>

                        <img v-if="cover.length > 0 && cover[0].url" :src="cover[0].url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </div>

                </div>
            </el-form-item>
            

            <el-form-item :label="$t('otherArrowPic')" required>
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text" v-if="scene_graph.length > 0" v-for="(item, index) in scene_graph" :key="index"> 

                        <input
                            type="file"
                            class="input-file"
                            name="avatar"
                            ref="avatarInput"
                            :disabled="disable"
                            @change="changeImage($event, 'scene_graph')"
                            accept="image/gif, image/jpeg, image/jpg, image/png"
                        >
                        <img v-if="item.url" :src="item.url" class="avatar">
                        <i class="el-icon-delete del" @click.stop="delPic('scene_graph', index)"></i>

                        <!-- <i v-if="!disable"  class="el-icon-plus avatar-uploader-icon"></i> -->
                    </div>
                    <div class="el-upload el-upload--text" > 
                          <input
                            type="file"
                            class="input-file"
                            name="avatar"
                            ref="avatarInput"
                            @change="changeImage($event, 'scene_graph')"
                            accept="image/gif, image/jpeg, image/jpg, image/png"
                        >

                        <i v-if="!disable"  class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                </div>
            </el-form-item>


            <el-form-item v-if="!disable">
                
                <el-button type="primary" v-if="form.title" @click="onSubmit">{{$t('edit')}}</el-button>

                <el-button type="primary" v-else @click="onSubmit">{{$t('save')}}</el-button>
            </el-form-item>
        </el-form>
        <el-dialog :visible="diaLog" :title="$t('pleaseSelectLocationInformation')">
            <div class="map-wrap">
                <div id="atlas" class="mapbox" style="width: 100%; height: 300px"></div>
                <div class="btn">
                    <!-- 确认 -->
                    <el-button type="primary" @click="close">{{$t('submit')}}</el-button>
                </div>
            </div>
            
        </el-dialog>


        </div>
    </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
import { TMap } from "@/utils/map.js";

export default {
    data() {
        return {
            diaLog: false, // 弹窗
            form: {
                type_id: '',
                title: '',
                phone: '',
                business_hours: '', // 营业时间
                area_id: '', // 省市县
                address: '',
                coordinate: '', // 经纬度
                desc: '',
                sign: '', // 标志图片
                cover: '', // 封面图,
                scene_graph: '', // 场景展示
            },
            options: [],
            upLoadUrl: apiBaseUrl + "api.html",
            value1: '',
            value2: '',
            arrTypeList: [],
            sign: [],
            cover: [],
            scene_graph: [],
            rules: {
                type_id: [
                    { required: true, message: this.$t('pleaseEnter.type'), trigger: 'change' }
                ],
                title:  [
                    { required: true, message: this.$t('pleaseEnter.arrowName'), trigger: 'blur' }
                ],
                phone:  [
                    { required: true, message: this.$t('pleaseEnter.phoneNumber'), trigger: 'blur' }
                ],
                area_id:  [
                    { required: true, message: this.$t('pleaseEnter.area'), trigger: 'change' }
                ],
                address:  [
                    { required: true, message: this.$t('pleaseEnter.address'), trigger: 'blur' }
                ],
                desc:  [
                    { required: true, message: this.$t('pleaseEnter.desc'), trigger: 'blur' }
                ]
            },
            areaname: '',
            userInfo: {},
            clubInfo: {},
            disable: false,
            selectedOptions: [],
            lat: 34.806615,
            lng: 113.564215,
            errTitle: '',
            cityKey: '',
            areaKey: '',
            provinceKey: '',
            id: ''
        }
    },
    watch: {
        cityKey() {
            this.selectedOptions = [this.provinceKey, this.cityKey, this.areaKey]
        }
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    created() {
        const _this = this
        this.$nextTick(function() {
            window.addEventListener("scroll", this.handleScroll);
        });
        this.clubAjax()
        
        if(localStorage.getItem('userToken')) {
            let addressList = this.$storage.get('areaList')
            if (addressList.hasOwnProperty('data')) {
                this.options = addressList.data;
            } else {
                this.options = addressList;
            }
            this.arrtype()

            this.$api.userInfo({}).then(res =>{
                this.userInfo = res.data
            })
        } else {
            this.$router.push({
                path: '/login'
            })
        }

        
    },
    methods: {
        delPic(val, index) {
            if(val == 'sign') {
                this.sign = []
            } 
            else if(val == 'cover') {
                this.cover = []
            } 
            else if(val == 'scene_graph') {
                this.scene_graph.splice(index, 1)
            }
        },
        clubAjax() {
            // 本账号的箭馆信息
        this.$api.clubStatus().then(res => {
            if(res.status) {
                // statues 1待审核 2审核成功 3=驳回
                if(res.data.type_id) {
                this.clubInfo = res.data
                this.id = res.data.id
                this.disable = res.data.status == 1
                // 驳回
                if(res.data.status == 3) {
                    this.errTitle = this.$t('applyToDismiss')
                }
                this.form = {
                    ...this.form,
                    type_id: res.data.type_id,
                    title: res.data.title,
                    phone: res.data.phone,
                    business_hours: res.data.business_hours, // 营业时间
                    area_id: res.data.area_id, // 省市县
                    address: res.data.address,
                    coordinate: res.data.latitude + ',' + res.data.longitude, // 经纬度
                    desc: res.data.desc,
                    sign: '', // 标志图片
                    cover: '', // 封面图,
                    scene_graph: '', // 场景展示
                }
                let hours = res.data.business_hours.split('-')
                this.value1 = hours[0] + ':00'
                this.value2 = hours[1] + ':00'

                this.cover = [{
                    url: res.data.cover_url,
                    image_id: res.data.cover
                }]
                
                this.sign = [{
                    url: res.data.sign_url,
                    image_id: res.data.sign
                }]
                
                let arr = []
                let str = ''
                if(res.data.scene_graph.length > 0 ) {
                    for(let i of res.data.scene_graph) {
                        arr.push({
                            url: i.url,
                            image_id: i.id
                        })
                        str += i.id + ','
                    }
                }

                this.scene_graph = arr
                this.form.scene_graph = str.substr(0, str.length - 1)
                this.getFullOptions(res.data.area_id, JSON.parse(localStorage.getItem('areaList')) );
                
            }

            }
        })

        },

        getFullOptions(id, data) {
            for (var i = 0; i < data.length; i++) {
                if (id == data[i].value) {
                if (!data[i].children) {
                    this.areaKey = data[i].value - 0;
                    return true;
                } else if (data[i].hasOwnProperty("children")) {
                    if (data[i].children[0] && !data[i].children[0].children) {
                    this.cityKey = data[i].value;
                    return true;
                    } else {
                    this.provinceKey = data[i].value;
                    return true;
                    }
                }
                } else {
                if (data[i].hasOwnProperty("children")) {
                    if (data[i].children[0] !== undefined) {
                    if (data[i].children[0].hasOwnProperty("children")) {
                        this.provinceKey = data[i].value;
                    } else {
                        this.cityKey = data[i].value;
                    }
                    }
                    if (typeof data[i].children != "undefined") {
                    var res = this.getFullOptions(id, data[i].children);
                    if (res) {
                        return true;
                    }
                    }
                }
                }
            }
        },
        handleScroll() {
            this.scrollTop = this.scrollTop =
                window.pageYOffset || document.body.scrollTop;
            if (this.scrollTop > 300) {
                this.toTopShow = true;
            } else {
                this.toTopShow = false;
            }
        },
        scrollToTop() {
            let timer = null,
                that = this;
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(function fn() {
                if (that.scrollTop > 0) {
                that.scrollTop -= 500;
                document.body.scrollTop = document.documentElement.scrollTop =
                    that.scrollTop;
                timer = requestAnimationFrame(fn);
                } else {
                cancelAnimationFrame(timer);
                that.toTopShow = false;
                }
            });
        },
        close() {
            this.diaLog = false
            this.form.coordinate = this.lat +',' + this.lng
        },
        // 地图显示
        mapClick() {
            if(!this.disable) {
                this.diaLog = true
                this.init();
            }
           
        },
        init() {
            return
            let myLatlng = new google.maps.LatLng(this.lat, this.lng)
            let marker 
            const _this = this
            this.$nextTick(() =>{
                var map = new google.maps.Map(document.getElementById('atlas'), {
                    center: new google.maps.LatLng(this.lat, this.lng),
                    zoom: 13
                })
                marker = new google.maps.Marker({
                    // position: new qq.maps.LatLng(event.latLng.Lat(), event.latLng.Lng()),
                    position: new google.maps.LatLng(this.lat, this.lng),
                    map: map
                });

                //绑定单击事件添加参数
                google.maps.event.addListener(map, 'click', function(event) {
                    console.log(event)
                    // alert('您点击的位置为: [' + event.latLng.getLat() + ', ' +
                    // event.latLng.getLng() + ']')
                    _this.lat = event.latLng.lat() 
                    _this.lng = event.latLng.lng() 
                    marker.setPosition(event.latLng);
                })
            })
        },
        getLng() {
            const _this = this
            this.$api.coordinatemap({
                key: 'VQ6BZ-RA5CW-IVARX-OCXRA-LTEVH-3MBKU',
                output: 'json',
                address: _this.areaname + '' + _this.form.address,
            }).then(res =>{
                _this.form.coordinate = res.result.location.lat + ',' + res.result.location.lng
            })
        },
        changeImage(e, type) {
            const _this = this
            let file = e.target.files[0];
            var formdata = new FormData();
            formdata.append("upfile", file, file.name);
            this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
                if (res.status) {
                    if(type == 'cover' || type == 'sign') {
                        _this.$set(_this.$data, type, [res.data])
                    } else {
                        this[type].push(res.data)
                    }
                }
            });
        },
        getName(v) {
            let arr = []
            for(let i of this.options) {
                if(i.value == v[0]) {
                    arr.push(i.label)
                    for(let j of i.children) {
                        if(j.value == v[1]) {
                            arr.push(j.label)
                            for(let k of j.children) {
                                if(k.value == v[2]) {
                                    arr.push(k.label)
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            return arr
        },
        cascaderChange(v) {
            this.areaname = this.getName(v).join('')
            this.form.area_id = v[2]
        },
        arrtype() {
            this.$api.getclublist().then(res => {
                if(res.status) {
                    this.arrTypeList = res.data
                }
            })
        },
        onSubmit() {
            const _this = this
            this.$refs.form.validate((valid) => {
                if(valid) {
                    if(!this.value1) {
                        this.$message({
                            message: this.$t('pleaseEnter.time'),
                            type: 'warning'
                        })
                        return
                    }
                    if(!this.value2) {
                        this.$message({
                            message: this.$t('pleaseEnter.time'),
                            type: 'warning'
                        })
                        return
                    }
                    if(this.sign.length > 0) {
                        this.form.sign = this.sign[0].image_id
                    } else {
                        this.$message({
                            message: this.$t('pleaseEnter.sign'),
                            type: 'warning'
                        })
                        return
                    }
                    if(this.cover.length > 0) {
                        this.form.cover = this.cover[0].image_id
                    } else {
                        this.$message({
                            message: this.$t('pleaseEnter.cover'),
                            type: 'warning'
                        })
                        return
                    }
                    if(this.scene_graph.length > 0) {
                        let a = []
                        for(let i of this.scene_graph) {
                            a.push(i.image_id)
                        }
                        this.form.scene_graph = a.join(',')
                    } else {
                        this.$message({
                            message: this.$t('pleaseEnter.otherArrowPic'),
                            type: 'warning'
                        })
                        return
                    }
                    this.form.business_hours = this.value1 +','+ this.value2
                    if(this.selectedOptions.length > 1) {
                        this.form.area_id = this.selectedOptions[2]
                    }

                    if(this.id) {
                        this.form.id = this.id
                    }

                    this.$api.clubjoin(this.form).then(res => {
                        if(res.status) {
                            _this.$message({
                                message: res.msg
                            })
                            setTimeout(() => {
                                // _this.$router.push({
                                //     path: '/arrowsapply'
                                // })


                                _this.clubAjax()
                                _this.scrollToTop()

                            }, 500)
                            
                        } else {
                            _this.$message({
                                message: res.msg
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.map-wrap {
    padding: 20px;
    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
    }
}
    .shop-container {
        background: #ffffff;
        background-size: cover;
        width: 100%;
        .shop-wrap {
            padding-top: 40px;
            margin: 0 auto;
            width: 1226px;
            background: url('~@/assets/images/arrow/ly.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    h1 {
        text-align: center;
        font-size: 36px;
        padding: 30px 0;
        color: #fff;
    }
    .el-form {
        width: 600px;
        margin: 0 auto;
        padding-top: 100px;
        padding-bottom: 40px;
        .el-form-item {
            // margin-bottom: 10px;
            &:last-child {
                padding-bottom: 30px;
            }
           
        }
    }

    .el-form-item {
        // margin-bottom: 0;
    }
</style>

<style>
 .el-form-item__content{
    line-height: 0;
}
.line {
    line-height: 40px  !important;
    color: #fff;
    padding-left: 10px;
}
.shop-container {
    /* width: 100%; */
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
  }
.avatar-uploader .el-upload .del{
    position: absolute;
    width: 30px;
    height: 30px;
    right: 0px;
    top: 1px;
    color: #fff;
    font-size: 24px;
    display: none;
    z-index: 99;
}
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
   .avatar-uploader .el-upload:hover .del {
       display: block;
   }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
    .input-file {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
        z-index: 99;
    }

    .el-col-11 .el-form-item {
        margin-bottom: 0 !important;
    }
</style>